export default function isDark() {
    return document.querySelector('body').classList.contains('dark');
}